import React, { useMemo } from "react";
import { ColorValue, StyleSheet, View, ViewStyle } from "react-native";
import { useTheme } from "../hooks/use-theme";

export type AlertBoxMode = "info" | "warning" | "error" | "success" | "secondary";

export type AlertBoxProps = {
    mode?: AlertBoxMode;
    style?: ViewStyle;
    testID?: string;
    children: React.ReactNode;
};

const AlertBox: React.FC<AlertBoxProps> = ({ mode, style, testID, children }) => {
    const { colors } = useTheme();
    const styles = useStylesheet();
    const background = useMemo(() => {
        switch (mode) {
            case "warning":
                return colors.warningBackground;
            case "error":
                return colors.errorBackground;
            case "info":
                return colors.infoBackground;
            case "success":
                return colors.successBackground;
            case "secondary":
                return colors.secondaryContainer;
            default:
                return colors.infoBackground;
        }
    }, [colors, mode]);

    return (
        <View
            testID={testID}
            style={[styles.callout, { backgroundColor: background as ColorValue }, style]}
        >
            {children}
        </View>
    );
};

const useStylesheet = () => {
    const theme = useTheme();
    return React.useMemo(() => {
        return StyleSheet.create({
            callout: {
                alignSelf: "stretch",
                paddingTop: 4,
                paddingBottom: 4,
                paddingHorizontal: theme.gridSize / 2,
                borderRadius: theme.roundness,
                flexDirection: "row",
            },
        });
    }, [theme]);
};

export default AlertBox;
